import { render, staticRenderFns } from "./TermsOfUseModal.component.html?vue&type=template&id=1dafabe8&scoped=true&external"
import script from "./TermsOfUseModal.component.ts?vue&type=script&lang=ts&external"
export * from "./TermsOfUseModal.component.ts?vue&type=script&lang=ts&external"
import style0 from "./TermsOfUseModal.component.scss?vue&type=style&index=0&id=1dafabe8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dafabe8",
  null
  
)

export default component.exports